import React from 'react'
import {Icon} from '@chakra-ui/react'

const SupportCartIcon = (props) => {
    return (
        <Icon viewBox="0 0 48 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.6312 35.9208L8.55438 2.89998H0.970008C0.434288 2.89998 0 2.46569 0 1.92997C0 1.39425 0.434288 0.959961 0.970008 0.959961H10.0771L11.6924 7.56413H47.0296C47.6555 7.56413 48.1175 8.14812 47.9736 8.75724L43.6121 27.2113C43.5086 27.649 43.1179 27.9582 42.6681 27.9582H16.6808L18.1539 33.9808H44.2531C44.7888 33.9808 45.2231 34.4151 45.2231 34.9508C45.2231 35.4865 44.7888 35.9208 44.2531 35.9208H16.6312ZM16.2062 26.0182H41.9006L45.8036 9.50414H12.1669L16.2062 26.0182Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.7404 37.7166C22.5082 37.7166 24.7507 39.9592 24.7507 42.727C24.7507 45.4941 22.5079 47.7373 19.7404 47.7373C16.9736 47.7373 14.7301 45.4938 14.7301 42.727C14.7301 39.9595 16.9733 37.7166 19.7404 37.7166ZM19.7404 39.6567C18.0447 39.6567 16.6701 41.031 16.6701 42.727C16.6701 44.4223 18.045 45.7972 19.7404 45.7972C21.4364 45.7972 22.8107 44.4227 22.8107 42.727C22.8107 41.0306 21.4367 39.6567 19.7404 39.6567Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40.1231 37.7166C42.8902 37.7166 45.1334 39.9595 45.1334 42.727C45.1334 45.4938 42.8899 47.7373 40.1231 47.7373C37.3557 47.7373 35.1128 45.4941 35.1128 42.727C35.1128 39.9592 37.3554 37.7166 40.1231 37.7166ZM40.1231 39.6567C38.4268 39.6567 37.0528 41.0306 37.0528 42.727C37.0528 44.4227 38.4272 45.7972 40.1231 45.7972C41.8185 45.7972 43.1934 44.4223 43.1934 42.727C43.1934 41.031 41.8189 39.6567 40.1231 39.6567Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default SupportCartIcon
